import { addStringPaths } from 'src/components/15-containers/SuperChargedWebView/communication/core/utils';
const EBAPIs = addStringPaths({
    keyboard: {
        event: true,
    },
    helperViews: {
        htmlEditor: {
            show: true,
        },
        snackbar: {
            show: true,
        },
        topicPicker: {
            show: true,
        },
        bottomDrawer: {
            show: true,
            hide: true,
        },
        popover: {
            show: true,
            hide: true,
        },
        imageViewer: {
            show: true,
            hide: true,
        },
        overlay: {
            show: true,
            hide: true,
            getState: true,
        },
        hiddenView: {
            render: true,
            clear: true,
        },
        playlist: {
            addToQueue: true,
            overrideQueue: true,
        },
        playlistPlayer: {
            stop: true,
        },
        filePicker: {
            pick: true,
        },
        datePicker: {
            pick: true,
        },
        pdfViewer: {
            show: true,
            hide: true,
        },
    },
    superChargedWV: {
        loaded: true,
    },
});
export default EBAPIs;
